import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

class BoxNoData extends Component {
  render() {
    const { respondent } = this.props;

    return (
      <p className="small">
        {`${respondent.firstName} ${respondent.lastName} `}
        <FormattedMessage
          id="assessment.survey.empty"
          defaultMessage="has not been invited to take any assessments/surveys, so far."
        />
      </p>
    );
  }
}

BoxNoData.propTypes = {
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default BoxNoData;
